import React from 'react'
import { selectData } from 'layouts/onboarding'

import { Card, Grid, Typography, Collapse } from '@mui/material'
import { ExpandMore } from '@mui/icons-material'
import { renderMuiFormField } from 'utils/forms/renderMuiFormField'

const dollarCentsFormat = Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
})

function SurvivorBenefit({
  collapseSections,
  toggleCollapse,
  survivorBenefitCost,
  survivorBenefitMonthlyPayout,
  intakeState,
  updateIntakeStateAtKey,
  updateIntakeStateAndSubmit,
  isGovernmentEmployee,
}) {
  const showSurvivorBenefitOwed = intakeState?.familyDivorcedOwedPension

  return (
    <>
      <Grid item xs={12} md={4} xl={3}>
        <Card
          sx={{
            overflow: 'visible',
            textAlign: 'left',
            boxShadow: '0px 4px 25px -8px rgba(0,0,0,0.2)',
            backgroundColor: '#f8f9fa',
            borderRadius: 2,
            p: 2,
          }}
        >
          <Grid container columnSpacing={3} rowSpacing={2}>
            <Grid item xs={12}>
              <Typography variant="valueTitle">VALUE POINTS</Typography>
              <Collapse
                in={collapseSections.survivorBenefit}
                style={{ width: '100%' }}
              ></Collapse>
            </Grid>
          </Grid>
        </Card>
      </Grid>
      <Grid item xs={12} md={8} xl={9}>
        <Card
          id="survivorbenefit"
          sx={{
            overflow: 'visible',
            textAlign: 'left',
            boxShadow: '0px 4px 25px -8px rgba(0,0,0,0.2)',
            borderRadius: 2,
            p: 2,
            pb: 0,
          }}
        >
          <Grid container columnSpacing={3} rowSpacing={2} pb={2}>
            <Grid
              item
              xs={12}
              onClick={() => toggleCollapse('survivorBenefit')}
              sx={{
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <Typography variant="h4" sx={{ flexGrow: 1 }}>
                Survivor Benefit
              </Typography>
              <ExpandMore
                sx={{
                  height: '1.5em',
                  width: '1.5em',
                  transform: collapseSections.survivorBenefit
                    ? 'rotate(180deg)'
                    : 'rotate(0deg)',
                  transition: 'transform 0.3s ease-in-out',
                }}
              />
            </Grid>
          </Grid>
          <Collapse
            in={collapseSections.survivorBenefit}
            style={{ width: '100%' }}
          >
            <Grid container columnSpacing={3} rowSpacing={2} pb={2}>
              <Grid item xs={12} sm={6}>
                {renderMuiFormField({
                  autoFocus: false,
                  id: 'survivorBenefitElection',
                  label: 'Survivor Benefit Election',
                  placeholder: 'Survivor Benefit Election',
                  inputType: 'select',
                  value: intakeState.survivorBenefitElection,
                  onChange: updateIntakeStateAndSubmit(
                    (survivorBenefitElection) =>
                      updateIntakeStateAtKey({ survivorBenefitElection })
                  ),
                  options: selectData.survivorBenefitElection,
                })}
                <Typography variant="inputNote" component="p">
                  Monthly Cost of the Benefit:{' '}
                  {dollarCentsFormat.format(survivorBenefitCost)}
                </Typography>
                <Typography variant="inputNote" component="p">
                  Monthly Payout of Benefit:{' '}
                  {dollarCentsFormat.format(survivorBenefitMonthlyPayout)}
                </Typography>
              </Grid>
              {showSurvivorBenefitOwed && isGovernmentEmployee ? (
                <Grid item xs={12} sm={6}>
                  {renderMuiFormField({
                    autoFocus: false,
                    id: 'familyDivorcedOwedPension',
                    label: 'Survivor Benefit Owed to Former Spouse',
                    placeholder: 'Survivor Benefit Owed to Former Spouse',
                    inputType: 'select',
                    value: intakeState.familyDivorcedOwedPension,
                    onChange: updateIntakeStateAndSubmit(
                      (familyDivorcedOwedPension) =>
                        updateIntakeStateAtKey({
                          familyDivorcedOwedPension,
                        })
                    ),
                    options: selectData.survivorBenefitElection,
                  })}
                </Grid>
              ) : (
                <></>
              )}
            </Grid>
          </Collapse>
        </Card>
      </Grid>
    </>
  )
}

export default SurvivorBenefit
